import React, { useState, useRef } from "react";
import "tailwindcss/tailwind.css";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLinkedin,
  FaInstagram,
  FaTwitter,
  FaArrowUp,
} from "react-icons/fa";
import axios from "axios";
import emailjs from "@emailjs/browser";

function Contact() {
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    message: "",
  });
  const contactInfoRef = useRef(null);
  const form = useRef();

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://port-front-flame.vercel.app/api/portfolio/contact",
        formData
      );
      setStatus("Message envoyé avec succès");
      setFormData({ nom: "", email: "", message: "" });
    } catch (error) {
      console.error("Erreur lors de l'envoi du message:", error);
      setStatus("Erreur lors de l'envoi du message");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_6r9c8i9",
        "template_idis1nc",
        form.current,
        "Be4QrHeLFFg2nBpVU"
      )
      .then(
        () => {
          alert("Message envoyé avec success !");
          form.current.reset();
        },
        (error) => {
          alert("Echec d'envoie, veuillez ressayer.", error);
        }
      );
  };

  return (
    <div
      className="bg-white min-h-screen flex flex-col relative"
      style={{ zIndex: "-5px" }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center backdrop-blur-md"
        style={{ backgroundImage: "url(/images/slide1.avif)" }}
      ></div>

      {/* Navbar */}
      <div className="relative "></div>

      <div className="flex-grow py-10 px-4 relative">
        <div className="container mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-[#03224C]">
              Contactez-moi
            </h1>
            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Pour toute question, n'hésitez pas à me contacter via les
              informations ci-dessous.
            </p>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
              <div className="text-center">
                <h2 className="text-lg sm:text-xl font-medium text-gray-800 flex items-center justify-center">
                  <FaPhone className="mr-2 text-blue-500" /> Téléphone
                </h2>
                <p className="text-gray-600 mt-2 text-sm md:text-base">
                  +212 620012887
                </p>
              </div>
              <div className="text-center">
                <h2 className="text-lg sm:text-xl font-medium text-gray-800 flex items-center justify-center">
                  <FaEnvelope className="mr-2 text-blue-500" /> Adresse email
                </h2>
                <p className="text-gray-600 mt-2 text-sm md:text-base">
                  reichbedelbella@gmail.com
                </p>
              </div>
              <div className="text-center">
                <h2 className="text-lg sm:text-xl font-medium text-gray-800 flex items-center justify-center">
                  <FaMapMarkerAlt className="mr-2 text-blue-500" /> Localisation
                </h2>
                <p className="text-gray-600 mt-2 text-sm md:text-base">
                  Maroc, Salé
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 sm:p-8 md:p-10 rounded-lg max-w-4xl mx-auto shadow-lg relative ">
            <form className="space-y-6" ref={form} onSubmit={sendEmail}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <input
                    type="text"
                    id="nom"
                    name="name"
                    value={formData.nom}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
                    placeholder="Votre nom"
                  />
                </div>
                <div className="flex flex-col">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
                    placeholder="Votre email"
                  />
                </div>
              </div>
              <div className="flex flex-col">
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
                  rows="5"
                  placeholder="Votre message"
                ></textarea>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="w-full sm:w-1/2 px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300 ease-in-out"
                >
                  Envoyer
                </button>
              </div>
            </form>
            {status && (
              <p className="text-center mt-4 text-gray-600">{status}</p>
            )}
            <div className="flex justify-center space-x-4 mt-6">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="text-blue-700 text-2xl hover:text-gray-900 transition duration-300 ease-in-out" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="text-red-700 text-2xl hover:text-gray-900 transition duration-300 ease-in-out" />
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter className="text-blue-700 text-2xl hover:text-gray-900 transition duration-300 ease-in-out" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Back to top button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-4 right-4 bg-[#03224C] text-white rounded-full p-3 shadow-lg hover:bg-blue-700 transition duration-300 ease-in-out"
        aria-label="Back to top"
      >
        <FaArrowUp className="text-xl" />
      </button>
    </div>
  );
}

export default Contact;
